import api from '../config/api';

const arqamService = {
  async getAccount() {
    const response = await api.get('/api/admin/arqam/account');
    return response.data;
  },
};

export default arqamService;
